<template>
    <div>Terpel, sin configuración adicional</div>
</template>